/**
 * Mint a fresh VehicleProfileId. Same pattern as `newStationId` — UUID v4
 * via crypto.randomUUID with a math-random fallback for type-check safety.
 */
import { VehicleProfileId } from '@/domain/types';

export function newVehicleProfileId(): VehicleProfileId {
  if (typeof globalThis !== 'undefined' && globalThis.crypto?.randomUUID) {
    return VehicleProfileId.of(globalThis.crypto.randomUUID());
  }
  const hex = (): string =>
    Math.floor(Math.random() * 0xffff)
      .toString(16)
      .padStart(4, '0');
  return VehicleProfileId.of(
    `${hex()}${hex()}-${hex()}-4${hex().slice(1)}-8${hex().slice(1)}-${hex()}${hex()}${hex()}`,
  );
}
